import clsx from 'clsx';
export function KeyHint({ children, className }: { children: string; className?: string }) {
  return <kbd className={clsx('inline-flex items-center h-5 px-1 hairline rounded-sm text-[10px] text-muted font-mono', className)}>{children}</kbd>;
}
